import { FlexBox } from '@ardoq/layout';
import { RowHeader } from '../../atoms';

const LabelFormattingRulesHeaderHorizontal = () => (
  <FlexBox gap="small" paddingX="xxlarge" paddingY="none">
    <RowHeader style={{ width: 250 }}>Type</RowHeader>
    <RowHeader>Field</RowHeader>
  </FlexBox>
);
export { LabelFormattingRulesHeaderHorizontal };
